import { render } from "./AppCommunicationEditModal.vue?vue&type=template&id=6b2574df"
import script from "./AppCommunicationEditModal.vue?vue&type=script&lang=js"
export * from "./AppCommunicationEditModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__